export default __webpack_public_path__ + "static/media/expand_more.9e3ba2c4.svg";